//工具类 
class Tool {
    //记录索引用，当通过递归搜索节点时，存在则这个值大于0
    public Index: number = 0 
    
    FormatToken(res: string) {
        console.log(res.replace("-", "+").replace("_", "/").split('.')[1])
        return decodeURIComponent(escape(window.atob(res.replace("-", "+").replace("_", "/").split('.')[1])));
    }
    //前端加密 //后端 HttpUtility.UrlDecode(
    // encodeURIComponent(res: string) { 
    //     return encodeURIComponent(res);
    // }
    GetQueryString(name: string) {
        const reg:RegExp = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")  ;
        let r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
        let context = "";
        if (r != null)
        context = r[2]; 
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    }
    FormatDate(val: number) {
        //PS：注意这个地方，要乘以1000
        const dt = new Date(val * 1000)
        const y = dt.getFullYear()
        const m = (dt.getMonth() + 1 + '').padStart(2, '0')
        const d = (dt.getDate() + '').padStart(2, '0')
        const hh = (dt.getHours() + '').padStart(2, '0')
        const mm = (dt.getMinutes() + '').padStart(2, '0')
        const ss = (dt.getSeconds() + '').padStart(2, '0')
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    }
    GetDate() {
        const dt = new Date()
        const y = dt.getFullYear()
        const m = (dt.getMonth() + 1 + '').padStart(2, '0')
        const d = (dt.getDate() + '').padStart(2, '0')
        const hh = (dt.getHours() + '').padStart(2, '0')
        const mm = (dt.getMinutes() + '').padStart(2, '0')
        const ss = (dt.getSeconds() + '').padStart(2, '0')
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
    }
    ClearLocalStorage() {
        localStorage.removeItem('nickname');
        localStorage.removeItem('token');
    }

    // //获取url参数
    // GetParam() {
    //     var url = location.search; //获取url中"?"符后的字串
    //     var theRequest //= new Object();
    //     if (url.indexOf("?") != -1) {
    //         var str = url.substr(1);
    //        var strs = str.split("&");
    //         for (var i = 0; i < strs.length; i++) {
    //             theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    //         }
    //     }
    //     return theRequest;
    //   }
    FindTree(tree: [], name: string) {
        if (tree != undefined && tree.length > 0) {
            tree.forEach((item: any) => {
                if (item.path == name) {
                    this.Index++
                } else {
                    this.FindTree(item.children, name)
                }
            })
        }
    }
}

export default Tool